import { DashboardConfig } from '../../../common/components/dashboards/types';
import { TimeSliderTypes } from '../../../common/components/timeslider/types';
import { Languages } from '../../../constants';
import {
  getAgeFactbox,
  getAttritionFactbox,
  getDemographicsAgeChart,
  getDemographicsCustomFilterChart,
  getDemographicsTenureChart,
  getFirstYearAttritionFactbox,
  getGenderRatioFactbox,
  getIndividualsFactbox,
  getJoinersFactbox,
  getJoinersLeaversByAgeChart,
  getJoinersLeaversOverTimeChart,
  getJoinersOverTimeWithBenchmarkChart,
  getLeaversFactbox,
  getLeaversOverTimeWithBenchmarkChart,
  getManagementRatioFactbox,
  getParentalLeaveFactbox,
  getTenureFactbox,
} from './shiphealthcare-chart-helpers';

export const ShipHealthcareDashboardChartConfig: DashboardConfig = {
  id: 'shiphealthcare_custom_db_1',
  title: {
    [Languages.EN]: 'Monthly Group Report',
    [Languages.JA]: 'SHIP人材諸表®（月次報告）',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'General Info',
        [Languages.JA]: '基本情報',
      },
      pageOptions: {
        displayOptions: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 5,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getIndividualsFactbox(storyboardDateUtils),
        getGenderRatioFactbox(storyboardDateUtils),
        getAgeFactbox(storyboardDateUtils),
        getTenureFactbox(storyboardDateUtils),
        getManagementRatioFactbox(storyboardDateUtils),
        getJoinersFactbox(storyboardDateUtils),
        getLeaversFactbox(storyboardDateUtils),
        getAttritionFactbox(storyboardDateUtils),
        getFirstYearAttritionFactbox(storyboardDateUtils),
        getParentalLeaveFactbox(storyboardDateUtils),
      ],
    },
    {
      pageId: '2',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 2,
      enabled: true,
      title: {
        [Languages.EN]: 'Demographics',
        [Languages.JA]: '人員構成',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 3,
      gridRows: 2,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getDemographicsCustomFilterChart(storyboardDateUtils, 1),
        getDemographicsAgeChart(storyboardDateUtils, 2),
        getDemographicsTenureChart(storyboardDateUtils, 3),
      ],
    },
    {
      pageId: '3',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 3,
      enabled: true,
      title: {
        [Languages.EN]: 'Joiners and Leavers',
        [Languages.JA]: '入社・離職',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 8,
      gridRows: 2,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getJoinersLeaversOverTimeChart(storyboardDateUtils),
        getJoinersLeaversByAgeChart(storyboardDateUtils),
        getJoinersOverTimeWithBenchmarkChart(storyboardDateUtils),
        getLeaversOverTimeWithBenchmarkChart(storyboardDateUtils),
      ],
    },
  ],
};
